import React, {useEffect} from 'react';
import {Provider} from 'react-redux';
import store from '../redux/store';
import MainLayout from '../components/layouts/MainLayout';
import PropTypes from "prop-types";
import '../styles/main.scss';
import {useNextCssRemovalPrevention} from "@madeinhaus/nextjs-page-transition";

const MyApp = ({Component, pageProps}) => {
  /**
   * Для просмотра консоли на мобильных устройствах
   * Пример: http://localhost:3000/?eruda=true
   */

  useEffect(() => {
    const appHeight = () => {
      const h = window.innerHeight;
      const w = window.innerWidth;
      const rulesDesk = w / h > 1600 / 852;
      const rulesMob = w / h > 375 / 736;

      const {style, classList} = document.getElementById('html-point');
      style.setProperty('--app-height', `${h}px`);
      style.setProperty('--app-width', `${w}px`);
      classList.toggle("landscape", rulesDesk);
      classList.toggle("landscape-mob", rulesMob);
      classList.toggle("portrait", !rulesDesk);
      classList.toggle("portrait-mob", !rulesMob);
    };
    window.addEventListener('resize', appHeight);
    appHeight()
  }, []);

  useNextCssRemovalPrevention();


  return (
    <Provider store={store}>
      <MainLayout {...pageProps}>
        <Component {...pageProps} />
      </MainLayout>
    </Provider>
  );
};

MyApp.propTypes = {
  Component: PropTypes.elementType,
  pageProps: PropTypes.object
};

export default MyApp;
